import { createStore } from 'vuex'

import AccountModule from "./account/AccountModule";
import NoticeModule from './notice/NoticeModule';
import SponsorModule from './sponsor/SponsorModule';
import AdminAccountModule from './admin/account/AdminAccountModule';
import AdminCategoryModule from './admin/category/AdminCategoryModule';
import AdminFaqModule from './admin/faq/AdminFaqModule';
import AdminNoticeModule from './admin/notice/AdminNoticeModule';
import AdminPopupModule from './admin/popup/AdminPopupModule';
import AdminSponsorModule from './admin/sponsor/AdminSponsorModule';
import AdminDonationGroupModule from './admin/donationGroup/AdminDonationGroupModule';
import DonationGroupModule from './donationGroup/DonationGroupModule';
import AdminCampaignModule from './admin/campaign/AdminCampaignModule';
import AdminCampaignPaymentModule from './admin/campaignPayment/AdminCampaignPaymentModule';
import AdminMerchantModule from './admin/merchant/AdminMerchantModule';
import CampaignModule from './campaign/CampaignModule';
import CategoryModule from './category/DonationGroupModule';
import AdminPartnerModule from './admin/partner/AdminPartnerModule';
import PaymentModule from './payment/PaymentModule';
import WeddingModule from './wedding/WeddingModule';
import FuneralModule from './funeral/FuneralModule';
import FaqModule from './faq/FaqModule';
import InquiryModule from './inquiry/InquiryModule';
import InvitationModule from './invitation/InvitationModule';
import AdminInquiryModule from './admin/inquiry/AdminInquiryModule';
import ReviewModule from './review/ReviewModule';
import AdminWeddingModule from './admin/wedding/AdminWeddingModule'
import AdminFuneralModule from './admin/funeral/AdminFuneralModule'
import AdminCampaignCategoryModule from './admin/campaignCategory/AdminCampaignCategoryModule';
import AdminDonationCategoryModule from './admin/donationCategory/AdminDonationCategoryModule';
import PartnerModule from './partner/PartnerModule';
import CampaignCategoryModule from './campaignCategory/CampaignCategoryModule';
import DonationCategoryModule from './donationCategory/DonationCategoryModule';
import ApiGuideModule from './apiGuide/ApiGuideModule';

export default createStore({
  modules: {
    accountModule: AccountModule,
    noticeModule : NoticeModule,
    sponsorModule : SponsorModule,
    adminAccountModule : AdminAccountModule,
    adminCategoryModule : AdminCategoryModule,
    adminFaqModule : AdminFaqModule,
    adminNoticeModule : AdminNoticeModule,
    adminPopupModule : AdminPopupModule,
    adminSponsorModule : AdminSponsorModule,
    adminDonationGroupModule : AdminDonationGroupModule,
    donationGroupModule : DonationGroupModule,
    adminCampaignModule : AdminCampaignModule,
    adminCampaignPaymentModule : AdminCampaignPaymentModule,
    adminMerchantModule : AdminMerchantModule,
    campaignModule: CampaignModule,
    adminPartnerModule: AdminPartnerModule,
    categoryModule : CategoryModule,
    paymentModule: PaymentModule,
    weddingModule: WeddingModule,
    funeralModule: FuneralModule,
    faqModule: FaqModule,
    inquiryModule: InquiryModule,
    invitationModule: InvitationModule,
    adminInquiryModule: AdminInquiryModule,
    reviewModule: ReviewModule,
    adminWeddingModule: AdminWeddingModule,
    adminFuneralModule: AdminFuneralModule,
    adminCampaignCategoryModule : AdminCampaignCategoryModule,
    adminDonationCategoryModule : AdminDonationCategoryModule,
    partnerModule: PartnerModule,
    campaignCategoryModule : CampaignCategoryModule,
    donationCategoryModule : DonationCategoryModule,
    apiGuideModule : ApiGuideModule
  }
})
